import { FC } from 'react';

import { useFormDataQuery } from '@/api/getters';
import { ConflictTypes } from '@/api/types';
import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

interface Props {
  className?: string;
}

const Conflict: FC<Props> = ({ className }) => {
  const { i18n } = useLingui();
  const { data } = useFormDataQuery();

  const conflictType = data?.conflict ?? data?.conflicts?.[0];

  const titleHelper = () => {
    switch (conflictType) {
      case ConflictTypes.WITHOUT_PESEL:
        return i18n.t('Zauważyliśmy brak PESEL');
      case ConflictTypes.CONTRACTS_ERROR:
        return i18n.t('Przykro nam, coś poszło nie tak');
      case ConflictTypes.TOO_MANY_COOWNERS:
        return i18n.t('Wymagana pomoc eksperta ');
      case ConflictTypes.VALIDATION:
        return i18n.t('Zauważyliśmy pewną niezgodność');
      case ConflictTypes.CONFLICTS_STAGE_IV_COMPLEMENTARY ||
        ConflictTypes.CONFLICTS_STAGE_IV:
        return i18n.t('Sprawdzamy Twoje dane');
      default:
        return i18n.t('Zauważyliśmy pewną niezgodność');
    }
  };

  const thankYouMessageHelper = () => {
    switch (conflictType) {
      case ConflictTypes.WITHOUT_PESEL:
        return i18n.t('Brak numeru PESEL nie stanowi przeszkody.');
      case ConflictTypes.CONTRACTS_ERROR:
        return i18n.t(
          'Wiemy, że generowanie Twoich dokumentów nie przebiegło zgodnie z planem i już nad tym pracujemy. '
        );
      case ConflictTypes.TOO_MANY_COOWNERS:
        return i18n.t(
          'Twój pojazd ma wielu współwłaścicieli i sprawa wymaga indywidualnej konsultacji, ale wszystko jest w porządku.'
        );
      case ConflictTypes.VALIDATION:
        return i18n.t(
          'Wiemy, że walidacja Twoich danych nie przebiegła zgodnie z planem i już nad tym pracujemy.'
        );
      case ConflictTypes.CONFLICTS_STAGE_IV:
        return i18n.t(
          'Wygląda na to, że mamy już część Twoich danych w systemie.'
        );
      case ConflictTypes.CONFLICTS_STAGE_IV_COMPLEMENTARY:
        return i18n.t(
          'Wygląda na to, że mamy już część Twoich danych w systemie, jednak zauważyliśmy pewne niezgodności.'
        );
      default:
        return i18n.t(
          'Wygląda na to, że mamy już część Twoich danych w systemie.'
        );
    }
  };

  const getConflictMessage = () => {
    switch (conflictType) {
      case ConflictTypes.CONFLICTS_STAGE_IV:
        return i18n.t(
          'W celu uniknięcia pomyłki w danych przeprowadzamy dodatkową weryfikację.'
        );
      case ConflictTypes.CONFLICTS_STAGE_IV_COMPLEMENTARY:
        return i18n.t(
          'Dbając o najwyższy standard obsługi, zwróciliśmy uwagę na pewne rozbieżności w dotychczas udzielonych odpowiedziach i postanowiliśmy przeprowadzić dodatkową weryfikację.'
        );
      case ConflictTypes.WITHOUT_PESEL:
        return i18n.t(
          'Nasz zespół podejdzie do Twojej sprawy indywidualnie, zapewniając najwyższą jakość obsługi.'
        );
      case ConflictTypes.TOO_MANY_COOWNERS:
        return i18n.t(
          'Aby zapewnić najwyższą jakość obsługi, jeden z naszych ekspertów dokładnie sprawdzi Twoje dokumenty i skontaktuje się z Tobą w celu dalszego postępowania. Proces przebiega zgodnie z planem, a my pracujemy nad jego pomyślnym zakończeniem.'
        );
      default:
        return null;
    }
  };

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={thankYouMessageHelper()}
      title={titleHelper()}
      withButton
      icon={'warning'}
      className={className}
    >
      {getConflictMessage()}
      <span>
        {i18n.t(
          'Jeśli potrzebujesz natychmiastowej pomocy, skontaktuj się z nami.'
        )}
      </span>
    </AfterDoc>
  );
};

export default Conflict;
